import React, { useState, useEffect, useRef } from "react";
import { __ } from "services/Translator";
import { Modal, Button } from "react-bootstrap";
import api from "services/api";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import GameSlider from "elements/games_elements/GameSlider";
import Slider from "react-slick";
import GameItem from "elements/games_elements/GameItem";
import ls from "services/ls";

const SearchPopUp = (props) => {
  const history = useHistory();
  const [searchStr, setSearchStr] = useState("");
  // const [showSrcPopUp, setShowSrcPopUp] = useState(false);

  const searchTextBox = useRef(null);

  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [expandSearchBar, setExpandSearchBar] = useState(true);
  const toggleExpandedSearchBar = (force) => {
    if (expandSearchBar) {
      setSearchSuggestions([]);
      if (force === true) {
        setSearchStr("");
        setExpandSearchBar(false);
      } else {
        if (searchStr.length === 0) {
          setExpandSearchBar(false);
        }
      }
    } else {
      setExpandSearchBar(true);
      searchTextBox.current.focus();
    }
  };

  const [recentSearch, setRecentSearch] = useState([]);

  const getSearchSuggestions = async () => {
    if (searchStr.length > 2) {
      var response = await api.get("/games/search-suggestions", {
        query: searchStr,
        // providers: props.selectedProviders,
        providers: [],
        extensiveInfo: true,
      });
      if (response.status === 200) {
        setSearchSuggestions(response.data);
        setTimeout(function () {
          // console.log("recentSearchLog", searchStr);
          handleSearch(searchStr);
        }, 10000);
      }
    } else {
      setSearchSuggestions([]);
    }
  };

  useEffect(() => {
    getSearchSuggestions();
  }, [searchStr]);

  useEffect(() => {
    const storedSearch = localStorage.getItem("recentSearchItems");
    // console.log("storedSearchstoredSearch", storedSearch);
    if (storedSearch) {
      setRecentSearch(JSON.parse(storedSearch));
    }
  }, []);

  const handleSearch = (searchStr) => {
    if (searchStr.length > 2) {
      if (!recentSearch.includes(searchStr)) {
        const updatedSearch = [...recentSearch, searchStr];
        setRecentSearch(updatedSearch);
        localStorage.setItem(
          "recentSearchItems",
          JSON.stringify(updatedSearch)
        );
      }
    }
  };
  const clearSearchHistory = () => {
    localStorage.setItem("recentSearchItems", JSON.stringify([]));
    setRecentSearch([]);
  };
  // games slider settings
  const gameNextLoad = () => {
    sliderRef.current.slickNext();
  };

  const gamePrevLoad = () => {
    sliderRef.current.slickPrev();
  };

  const gamesSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },

      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const sliderRef = useRef();

  return (
    <>
      <Link
        onClick={() => {
          props.setShowSrcPopUp(true);
        }}
        className="searcbox_area"
      >
        <i class="far fa-search"></i>
      </Link>
      <Modal
        show={props.showSrcPopUp}
        onHide={() => props.setShowSrcPopUp(false)}
        dialogClassName={
          (props.isMobileDevice ? "modal-100w" : "modal-70w") + " searchModal"
        }
        aria-labelledby="example-custom-modal-styling-title"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {__("Search")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchContent">
            <div className="games_filter">
              <div className="search_bar">
                <input
                  placeholder={__("Search Here...")}
                  value={searchStr}
                  onChange={(ev) => setSearchStr(ev.target.value)}
                  type="text"
                  className="searchbox_searchgames"
                  ref={searchTextBox}
                />
                {searchStr.length > 0 && (
                  <div onClick={() => setSearchStr("")} className="search_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 50 50"
                      style={{ marginTop: "-9px" }}
                    >
                      <path
                        fill="#fff"
                        d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125 L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375 6.3125 L 25 22.15625 Z"
                      ></path>
                    </svg>
                  </div>
                )}
                {searchStr.length < 1 && (
                  <div
                    onClick={() => toggleExpandedSearchBar(true)}
                    className="search_btn"
                  >
                    <i className="far fa-search"></i>
                  </div>
                )}
              </div>
              <span className="src_msg">
                {__("Enter at least 3 symbols to start searching")}
              </span>
              {!!recentSearch.length && (
                <div className="recent_search_container">
                  <div className="recent_search_heading">
                    <div className="heading_text">{__("Recent searches")}</div>
                    <div onClick={clearSearchHistory} className="clear_history">
                      {__("Clear History")}
                    </div>
                  </div>
                  <div className="recent_search_result">
                    <ul>
                      {recentSearch.map((search, index) => (
                        <li
                          onClick={() => {
                            setSearchStr(search);
                          }}
                          key={index}
                        >
                          {search}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </div>
            {!!searchSuggestions.length && (
              <div className="search_results">
                <section className="game_section">
                  <div className=" game_container padding_top_bottom_30">
                    <div className="section_headline">
                      <div className="headline_text">{__("Search Result")}</div>
                      <div className="headline_action">
                        <button onClick={gamePrevLoad} className="action_btn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="20"
                            fill="white"
                            class="bi bi-arrow-left"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                            />
                          </svg>
                          {__("Prev")}
                        </button>
                        <button onClick={gameNextLoad} className="action_btn">
                          {__("Next")}

                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="20"
                            fill="white"
                            class="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    <Slider ref={sliderRef} {...gamesSettings}>
                      {searchSuggestions.map((game, index) => (
                        <GameItem
                          game={game}
                          isAuthenticated={props.isAuthenticated}
                          landingType={props.landingType}
                          key={index}
                        />
                      ))}
                    </Slider>
                  </div>
                </section>
              </div>
            )}

            <GameSlider
              categoryName="Popular"
              category="popular"
              perPage="20"
              {...props}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SearchPopUp;
